//cspell:ignore suscribe Suscribe
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { UseFormWatch } from 'react-hook-form';

import { IWhatsAppTemplateFormV0 } from './useWhatsAppTemplateForm';

import { atomCurrentWhatsAppTemplate } from '@/modules/CampaignsModule/atoms/actionWhatsAppAtom';
import {
  IWhatsAppTemplate,
  UrlAction,
  WHATSAPP_ACTION_TYPES,
  WhatsAppAction,
} from '@/modules/CampaignsModule/interfaces/WhatsApp';

type UseSuscribeWhatsAppTemplateFormProps = {
  watch: UseFormWatch<IWhatsAppTemplateFormV0>;
};

export const useSuscribeWhatsAppTemplateForm = ({
  watch,
}: UseSuscribeWhatsAppTemplateFormProps) => {
  const [currentWhatsAppTemplate, setCurrentWhatsAppTemplate] = useAtom(
    atomCurrentWhatsAppTemplate
  );
  const [currentTemplate, setCurrentTemplate] =
    useState<IWhatsAppTemplate>(currentWhatsAppTemplate);

  useEffect(() => {
    const subscription = watch((fields) => {
      setCurrentTemplate((prevTemplate) => {
        const actionsFromForm = Array.isArray(fields.actions) ? fields.actions : [];
        const actions: WhatsAppAction[] = actionsFromForm
          .filter(
            (action): action is { title: string; url: string } =>
              action !== undefined && action.title !== undefined && action.url !== undefined
          )
          .map((action) => {
            return {
              type: WHATSAPP_ACTION_TYPES.URL,
              title: action.title,
              url: action.url || '',
            } as UrlAction;
          });

        let selectedTemplateType: 'twilio/text' | 'twilio/media' | 'whatsapp/card' = 'twilio/text';

        if ((fields.footer && fields.footer.length > 0) || actions.length > 0) {
          selectedTemplateType = 'whatsapp/card';
        } else if (fields.header_select?.id === 'media') {
          selectedTemplateType = 'twilio/media';
        } else if (fields.header_select?.id === 'text') {
          selectedTemplateType = 'whatsapp/card';
        } else {
          selectedTemplateType = 'twilio/text';
        }

        let newTypes: IWhatsAppTemplate['types'] = {};
        switch (selectedTemplateType) {
          case 'twilio/media':
            newTypes = {
              'twilio/media': {
                body: fields.message || '',
                media: fields.media_url ? [fields.media_url] : [],
              },
            };
            break;
          case 'whatsapp/card':
            newTypes = {
              'whatsapp/card': {
                body: fields.message || '',
                ...(fields.header_select?.id === 'text'
                  ? { header_text: fields.header_text || '' }
                  : { media: fields.media_url ? [fields.media_url] : [] }),
                footer: fields.footer || '',
                actions: actions,
              },
            };
            break;
          default:
            newTypes = {
              'twilio/text': {
                body: fields.message || '',
              },
            };
            break;
        }

        const updatedTemplate: IWhatsAppTemplate = {
          ...prevTemplate,
          friendly_name: fields.title || '',
          types: newTypes,
        };

        setCurrentWhatsAppTemplate(updatedTemplate);

        return updatedTemplate;
      });
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [watch, setCurrentWhatsAppTemplate]);

  return { currentTemplate };
};
